$(document).ready(function() {
  // Carousel - Masthead
  var $slides = $(".pom-banner .masthead-slide");
  var makeCarousely = ($slides.length > 1);

  $(".pom-banner .owl-carousel").owlCarousel({
    loop: makeCarousely,
    autoplay: makeCarousely,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    paginationSpeed: 500,
    rewind: false,
    items: 1,
    nav: false,
    dots: makeCarousely,
    mouseDrag: makeCarousely
  });

  var owlCarousel = $('.pom-banner .owl-carousel');
  owlCarousel.mouseover(function(){
    owlCarousel.trigger('stop.owl.autoplay');
  });

  owlCarousel.mouseleave(function(){
    owlCarousel.trigger('play.owl.autoplay',[1000]);
  });
  
  // Carousel - List of clients
  $(".client-lst .owl-carousel").owlCarousel({
    loop: true,
    autoplay: true,
    rewind: false,
    paginationSpeed: 500,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    nav: false,
    dots: true,
    mouseDrag: true,
    responsive: {
      0: {
        items: 1
      },
      500: {
        items: 2
      },
      768: {
        items: 3
      },
      1000: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  });
});
